// @workflow tasks.show-in-3d
/**
 * The task board's viewer panel, as the task actions see it. The board (Task/views/index.vue)
 * owns the panel (ViewersSection + ViewerTaskColoring) and registers it here while it is on
 * screen, so its own buttons and the assistant (its own Vue root, sharing only the store and
 * router) reach the same panel, with no `$refs` from outside and no `store.state.mainApp`.
 *
 * Surface contract:
 *   facilityId() → string|null            the facility the board shows
 *   setIsolationInfo(infoByTaskId) → void  the tasks' server isolation plans (colouring overlay)
 *   present({ tags, tab }) → void          open the panel on these tags, on that tab
 *   load3d() / load2d(planUrn) / load360(image, tag) → Promise   the panel's viewers
 *   paint3d() → Promise                    choose the colour encoding and render (ViewerTaskColoring)
 *   nextTick() → Promise
 *   notify: { warning(text), error(text) }
 * No imports, so `npm run test:unit` (node --test) can load it directly.
 */

let current = null;

/**
 * @param {object} surface the board's panel
 * @returns {() => void} unregisters it, unless another board registered since
 */
export function registerTaskBoardSurface(surface) {
  current = surface;
  return () => {
    if (current === surface) current = null;
  };
}

/** @returns {object|null} the task board panel on screen, or null */
export function taskBoardSurface() {
  return current;
}
